// Modules
// import { Suspense } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
// Components
import Landing from "../Components/Pages/Landing/Landing";
import Login from "../Components/Pages/Authentication/Login/Login";
import Register from "../Components/Pages/Authentication/Register/Register";
// Syles
import "./Styles/App.css";
import SinglePage from "../Components/Pages/SinglePage/SinglePage";
import Library from "../Components/Pages/Library/Library";
import Panel from "../Components/Pages/Authentication/Panel/Panel";
import VerifyPayment from "../Components/Pages/Authentication/VerifyPayment/VerifyPayment";
import ErrorPayment from "../Components/Pages/Authentication/ErrorPayment/ErrorPayment";
import ForgetPassword from "../Components/Contents/ForgetPass/ForgetPassword";
import ChangePassword from "../Components/Contents/ForgetPass/ChangePassword";
import QuarterlyLibrary from "../Components/Pages/QuarterlyLibrary/QuarterlyLibrary";
// import PdfLibrary from "../Components/Pages/Library/PdfLibrary";

function App() {
  return (
    <BrowserRouter>
      {/* <Suspense fallback={}> */}
      <Switch>
        <Route exact path="/">
          <Landing />
        </Route>
        <Route exact path="/users/verify-payment">
          <VerifyPayment />
        </Route>
        <Route exact path="/users/error-payment">
          <ErrorPayment />
        </Route>
        <Route exact path="/contact-us">
          <Landing />
        </Route>
        <Route exact path="/about-us">
          <Landing />
        </Route>
        <Route exact path="/library">
          <Landing />
        </Route>
        <Route exact path="/library/my-books">
          <Landing />
        </Route>
        <Route exact path="/library/single-book/:bookId">
          <Library />
          {/* <PdfLibrary /> */}
        </Route>
        <Route exact path="/quarterly">
          <Landing />
        </Route>
        <Route exact path="/library/my-quarterlys">
          <Landing />
        </Route>
        <Route exact path="/library/single-quarterly/:quarterlyId">
          <QuarterlyLibrary />
        </Route>
        <Route exact path="/users/panel">
          <Panel />
        </Route>
        <Route exact path="/users/panel/cart">
          <Panel />
        </Route>
        <Route exact path="/image-articles">
          <Landing />
        </Route>
        <Route exact path="/journal">
          <Landing />
        </Route>
        <Route exact path="/article/:category/:id">
          <SinglePage />
        </Route>
        <Route exact path="/users/login">
          <Login />
        </Route>
        <Route exact path="/users/register">
          <Register />
        </Route>
        <Route exact path="/users/forget-password">
          <ForgetPassword />
        </Route>
        <Route exact path="/users/reset-password/:token">
          <ChangePassword />
        </Route>
      </Switch>
      {/* </Suspense> */}
    </BrowserRouter>
  );
}

export default App;
